import React, {useEffect, useRef, useState} from 'react';
import {isUpdate} from "../commonmethod/CommonMethod";
import {valid, validator} from "../commonmethod/ValidationChecker";

/**
 * update : 등록페이지가 아니라 수정페이지일 경우
 * */

/*
* Todo api로딩이 안된건지 값 자체가 없는건지 구분해서 skeleton 을 보여줘야 한다.
* */
function SimmsInputSearch({data, style, onKeyDown, constraint, target, auth, clicked, setClicked, placeHolder,...rest}) {
    const [value, setValue] = useState(data);
    const {updatedStyle, isRequiredError} = validator(constraint, data, style);
    const inputRef = useRef(null);


    const handleChange = (e) => {
        setValue(e.target.value)
    }

    const handleKeyDown = (e) => {
        if(onKeyDown && e.keyCode === 13) {
            e.preventDefault();          // 폼 submit 방지
            e.stopPropagation();         // 상위로 버블링 방지
            // 일부 라이브러리의 전역 key 핸들러까지 차단
            if (e.nativeEvent.stopImmediatePropagation) {
                e.nativeEvent.stopImmediatePropagation();
            }

            onKeyDown(value, e);
        }
    }

    return (
            <input
                ref={inputRef}
                type={"text"}
                hidden={rest?.type==='HIDDEN'}
                className={`search-basic-input `}
                placeholder={placeHolder ?? "자산명,자산코드 검색"}
                style={updatedStyle}
                {...rest}
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
    );
}

export default SimmsInputSearch;